import React from "react";
import { Container, Row, Col } from "shards-react";
import ClientInvoicingConfig from "../components/contacts/ClientChargeInvoicingConfig";

const ClientInvoicingConfigView = props => {
  const { id } = props.match.params;
  return (
    <Container fluid className="main-content-container px-4 pb-4">
      <ClientInvoicingConfig id={id} />
    </Container>
  );
};

export default ClientInvoicingConfigView;
